import { CustomHeaderComponent } from "../../components/custom-header/custom-header.component";
import { EmailListComponent } from "../../email-list/email-list.component";
import { IntegrationListComponent } from "../../integrations/integrations-list.component";
import { OutgoingEventsHybridComponent } from "../../outgoing-events-hybrid/outgoing-events-hybrid.component";

export const EMAIL_LIST_ROUTES = [
	{
		path: 'email-list',
		component: EmailListComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: ''
			}
		},
	}
];

export const OUTGOING_EVENTS_HYBRID_ROUTES = [
	{
		path: 'outgoing-events',
		component: OutgoingEventsHybridComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: ''
			}
		},
	}
]

export const CLIENT_IDENTIFIER_LIST_ROUTES = [
	{
		path: 'integrations-list',
		component: IntegrationListComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: ''
			}
		},
	},
];

export const PRODUCT_IDENTIFIER_LIST_ROUTES = [
	{
		path: 'product-identifier',
		component: IntegrationListComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: ''
			}
		},
	},
];
